import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DebugModeShortcut } from '@/components/debug/DebugModeShortcut';
import { Toaster } from '@/components/ui/sonner';
import { AdminLayoutWrapper } from '@/features/admin/components/AdminLayoutWrapper';
import { UserRoles } from '@/lib/constants/auth.constants';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute('/admin')({
  component: RouteComponent,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  ssr: false,
});

function RouteComponent() {
  return (
    <AdminLayoutWrapper>
      <Outlet />
      <DebugModeShortcut />
      <Toaster />
    </AdminLayoutWrapper>
  );
}
